
export const minimizeText = function(input: string, width: number = 100) {
  return input.length > width ? input.substring(0, width - 3) + '...' : input;
};
